import { render, staticRenderFns } from "./WorkCard.vue?vue&type=template&id=1d2c76ca&scoped=true"
import script from "./WorkCard.vue?vue&type=script&lang=js"
export * from "./WorkCard.vue?vue&type=script&lang=js"
import style0 from "./WorkCard.vue?vue&type=style&index=0&id=1d2c76ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c76ca",
  null
  
)

export default component.exports